import GroupCloseModal from './GroupCloseModal';
import GroupCloseModalContainer from './GroupCloseModal.container';
export default GroupCloseModalContainer(GroupCloseModal);
